import {sessionResourceTooltipMessages} from '../constants';

export const getLinkTooltip = (isDeleted: boolean, isExpired: boolean) => {
  if (isExpired) return sessionResourceTooltipMessages.expired;
  if (isDeleted) return sessionResourceTooltipMessages.deleted;

  return null;
};
